import { createContext } from "react";
interface StepTwoFormContextProps {
    postPaymentMethod:      () => Promise<void>,
}

export const StepTwoFormContext = createContext({} as StepTwoFormContextProps);